// extracted by mini-css-extract-plugin
module.exports = {"box":"item-module--box--17XvS"};